import React, { useEffect, useState } from "react";
function AppHeaderDetail({ setLoading, fetchData, title, name, isShowTable }) {

    useState(() => {
        document.title = title;
    }, []);

    const handleTouchStart = (e) => {
    };

    const handleTouchMove = (e) => {
        setLoading(true)
    };

    const handleTouchEnd = () => {
        fetchData();
        setLoading(false)
    };
    const backBtn = () => {
        window.history.back();
    }

    return (
        <div>
            <div>
                <div className="heading"
                    style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ display: "flex", justifyContent: "flex-start" }}>
                        <i style={{ fontSize: '20px' }} className="fa-solid fa-arrow-left icon-white" onClick={backBtn}></i>
                        <div className="" onTouchStart={e => { handleTouchStart(e); }}
                            onTouchMove={e => { handleTouchMove(e); }}
                            onTouchEnd={e => { handleTouchEnd(e) }}
                            style={{ alignItems: "baseline", height: "25px", width: "100%" }}>
                            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                <label className="head-title-ot">{title}</label>
                            </div>
                        </div>
                    </div>
                    <div>
                        {isShowTable && isShowTable == true && (
                            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                <label className="head-title-ot">{name}</label>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}


export default AppHeaderDetail;
